import {ESLBaseElement} from '@exadel/esl/modules/esl-base-element/core';
import {isRelativeNode} from '@exadel/esl/modules/esl-utils/dom/traversing';
import {ESLMediaQuery, ESLMediaRuleList} from '@exadel/esl/modules/esl-media-query/core';

import View from 'core/view';
import {DEFAULT_BP_TUPLE} from 'core/helpers/breakpoints';
import {unwrap} from 'core/helpers/dom';

import {replaceQuoteMarks} from './content-block.quotes';

class ContentBlock extends View {
  static dykVPaddings = ESLMediaRuleList.parseTuple(DEFAULT_BP_TUPLE, '50|50|60|0|0', Number);
  static componentName = 'ContentBlock';
  static defaults = Object.assign({}, View.defaults);

  init() {
    this.video = this.find('.item-media smart-media').get(0) || null;
    this.image = this.find('.item-media smart-image').get(0) ||
      this.find('.item-media .svg-image').get(0) || null;
    this.cta = this.find('.item-media .item-cta').get(0) || null;
    this.$dykContainer = this.find('.did-you-know-container');
    this.dykContainer = this.$dykContainer.get(0) || null;
    this.shareButton = this.find('esl-share');
    this.title = this.find('.cb-title');
    this.description = this.find('.cb-desc');

    if (this.video && (this.cta || this.dykContainer)) {
      this.bindEvents('{window} on:breakpointchange', this.onBreakpointChange);
    }
    if (this.shareButton.length !== 0) {
      this.initShareButton();
    }
    if (this.dykContainer) {
      this.replaceQuoteMarks();
      this.initDykContainer();
    }
  }

  initShareButton() {
    if (this.title.length !== 0 && this.title.text() !== '') {
      this.shareButton.attr('share-title', this.title.clone().children().remove().end().text().trim());
    } else if (this.description.length !== 0 && this.description.text() !== '') {
      this.shareButton.attr('share-title', this.description.text().trim());
    }
  }

  onBreakpointChange(current) {
    if (current === 'xs') {
      if (this.cta) {
        this.cta.title = this.image.title;
      } else if (this.dykContainer) {
        this.dykContainer.title = this.image.title;
      }
    } else {
      if (this.cta) {
        this.cta.title = this.video.title;
      } else if (this.dykContainer) {
        this.dykContainer.title = this.video.title;
      }
    }
  }

  replaceQuoteMarks() {
    const $quoteTextElement = this.$dykContainer.find('.dyk-quote-text').get(0);
    if ($quoteTextElement) {
      replaceQuoteMarks($quoteTextElement);
    }
  }

  initDykContainer() {
    this.$dykWrapper = this.$dykContainer.find('.dyk-wrapper');
    this.$dykInner = this.$dykContainer.find('.dyk-inner');
    this.$itemMedia = this.find('.item-media');
    this.calcDykSize();
    this.$dykContainer.addClass('initialized');
    this.bindEvents('{window} on:resize', this.calcDykSize);
    this.bindEvents('on:content-block:update-dyk', this.calcDykSize);
    this.bindEvents('{window} on:esl:refresh', this.calcDykSize);
  }

  calcDykSize(e) {
    if (e && e.type === ESLBaseElement.prototype.REFRESH_EVENT && !isRelativeNode(unwrap(this.$el), unwrap(e.target))) return;
    this.$dykWrapper.removeClass('wide');
    this.$itemMedia.removeClass('expanded');
    this.$itemMedia.css('height', '');
    if (this.$dykInner.outerHeight() > this.$dykWrapper.height() || this.$dykInner.outerWidth() > this.$dykWrapper.width()) {
      if (ESLMediaQuery.for('@+LG').matches) {
        this.$dykWrapper.addClass('wide');
      } else {
        const newHeight = this.$dykInner.outerHeight() + ContentBlock.dykVPaddings.value; // DYK-block + 2 paddings
        this.$itemMedia.height(newHeight);
        this.$itemMedia.addClass('expanded');
      }
    }
  }
}

export default ContentBlock;
